var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isActive)?_c('vue-draggable-resizable',_vm._g(_vm._b({staticClass:"panel-card",attrs:{"z":_vm.vOrder},on:{"activated":_vm.onActivated}},'vue-draggable-resizable',_vm.$props,false),_vm.$listeners),[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }